import $ from "jquery";
import 'slick-carousel';

export function sliderSetting() {

    //物件詳細 メイン画像
    $('.detail_images_slider').slick({
        slidesToShow: 1,
        infinite: true,
        arrows: true,
        dots: true,
        dotsClass: 'detail_images_thumbs',
        customPaging: function (slick, index) {
            let targetImage;
            let currentElm = slick.$slides.eq(index);


            if ( currentElm.find('iframe').length > 0 ){
                let videoUrl = slick.$slides.eq(index).find('iframe').attr('src');
                let videoId = videoUrl.split('/').slice(-1)[0];
                let slideTypeClass = 'movie';
                targetImage = 'https://img.youtube.com/vi/' + videoId + '/mqdefault.jpg';
                return '<i class="' + slideTypeClass + '"></i><img src=" ' + targetImage + ' "/>';
            }
            else if (currentElm.find('[data-youtube_url]').length > 0){
                let videoId;

                videoId = slick.$slides.eq(index).find('[data-youtube_url]').attr('data-youtube_url').split('/').slice(-1)[0];

                let slideTypeClass = 'movie';
                targetImage = 'https://img.youtube.com/vi/' + videoId + '/mqdefault.jpg';
                return '<i class="' + slideTypeClass + '"></i><img src=" ' + targetImage + ' "/>';
            }
            else {
                targetImage = slick.$slides.eq(index).find('img').attr('src');
                return '<img src=" ' + targetImage + ' "/>';
            }
        }
    })


    //TOP オススメ
    let recommendList = document.getElementById('recommend_list');
    if (recommendList) {
        if (matchMedia("(max-width: 1024px)").matches) {
            $('.top_recommend_list').slick({
                infinite: true,
                arrows: true,
                centerMode: true,
                centerPadding: '0',
                slidesToShow: 1,
                slidesToScroll: 1,
            })
        }
        else if (
          recommendList.children.length >= 4 &&
          document.body.id === 'list'
        ) {
            $('.top_recommend_list').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                centerMode: false,
                centerPadding: 0,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    },
                ]
            })
        }
        else if (recommendList.children.length >= 6) {
            $('.top_recommend_list').slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                centerMode: false,
                centerPadding: '0',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    },
                ]
            })
        }
        else if (recommendList.children.length < 6) {
            recommendList.classList.add('no-slider')
        }
    }

    //TOP 開業実績
    let archiveList = document.getElementById('top_archive_list');
    if (archiveList) {
        if (matchMedia("(max-width: 1024px)").matches) {
            $('.top_archive_list').slick({
                infinite: true,
                arrows: true,
                centerMode: true,
                centerPadding: '0',
                slidesToShow: 1,
                slidesToScroll: 1,
            })
        }
    }

    //物件詳細 関連物件
    let relationList = document.getElementById('relation_list');
    if (relationList) {
        if (matchMedia("(max-width: 1024px)").matches) {
            $('.detail_relation_list').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                centerMode: true,
                centerPadding: '0',
            })
        } else if (relationList.children.length >= 6) {
            $('.detail_relation_list').slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                centerMode: false,
                centerPadding: '0',
            })
        } else if (relationList.children.length < 6) {
            relationList.classList.add('no-slider')
        }
    }

    //マイページ お気に入り
    let favoriteList = document.getElementById('favorite_list');
    if (favoriteList) {
        if (matchMedia("(max-width: 1024px)").matches) {
            $('.mypage_favorite_list').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                centerMode: true,
                centerPadding: '0',
            })

        } else if (favoriteList.children.length >= 6) {
            $('.mypage_favorite_list').slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                centerMode: false,
                centerPadding: '0',
            })
        } else if (favoriteList.children.length < 6) {
            favoriteList.classList.add('no-slider')
        }
    }


    //マイページ 閲覧履歴
    let historyList = document.getElementById('history_list');
    if (historyList) {
        if (matchMedia("(max-width: 1024px)").matches) {
            $('.mypage_history_list').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                arrows: true,
                centerMode: false,
                centerPadding: '0',
            })
        } else if (historyList.children.length >= 6) {
            $('.mypage_history_list').slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                infinite: false,
                arrows: true,
                centerMode: false,
                centerPadding: '0',
            })
        } else if (historyList.children.length < 6) {
            historyList.classList.add('no-slider')
        }
    }
}
